import { useLocation, useRoutes } from 'react-router-dom'
import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider } from 'next-themes'
import { RecoilRoot } from 'recoil'
import '@fontsource/nunito/400.css'
import '@fontsource/nunito/700.css'

import {
    AskCreditCard,
    CartSidebar,
    Footer,
    GlobalSnackbar,
    Header,
    InitialiseStores,
} from '@/components/app'
import { router } from './router'
import { useThemeStore } from './stores/app/theme'
import { useOrderCreateStore } from './stores/orders/create'

import { isLogged } from '@/utils/auth'
import { urls } from '@/utils/constants'
import { defaultPalette } from '@/theme/defaultPalette.css'

import * as styles from './App.css'

const App = () => {
    const { pathname } = useLocation()

    const theme = useThemeStore((state) => state.theme)

    const canDisplayCartSidebar = useOrderCreateStore(
        (state) => state.canDisplayCartSidebar,
    )

    const routing = useRoutes(router(isLogged()))

    const canDisplayHeaderAndFooter = !(
        pathname.includes(urls.auth.ACTIVATION) ||
        pathname.includes(urls.auth.LOGIN) ||
        pathname.includes(urls.auth.REGISTER) ||
        pathname.includes(urls.auth.RESET_PASSWORD)
    )

    return (
        <>
            {/* @ts-expect-error Wait type */}
            <ThemeProvider
                attribute='class'
                defaultTheme='default'
                value={{
                    default: defaultPalette,
                }}
            >
                <MuiThemeProvider theme={theme}>
                    <RecoilRoot>
                        <StyledEngineProvider injectFirst>
                            <CssBaseline />

                            <InitialiseStores />

                            <GlobalSnackbar />

                            <AskCreditCard />

                            {!!canDisplayHeaderAndFooter && <Header />}

                            <div className={styles.content}>
                                {/* eslint-disable-next-line react/jsx-max-depth */}
                                <main>{routing}</main>

                                {!!canDisplayCartSidebar && <CartSidebar />}

                                {!!canDisplayHeaderAndFooter && <Footer />}
                            </div>
                        </StyledEngineProvider>
                    </RecoilRoot>
                </MuiThemeProvider>
            </ThemeProvider>
        </>
    )
}

export default App
